import React from "react"

import classNames from "classnames/bind"
import styles from "../styles/Result.module.scss"
import { withTranslation, Trans } from "react-i18next"
import "../i18n/i18n"

import { typeList } from "../constants/type"

export class ResultContents extends React.Component {
  render() {
    const { type, t, sharedResult } = this.props
    const typeId = typeList[type]["id"]

    // i18n translated된 결과를 array로 받기
    const descList = t(`result.type${typeId}.desc`, { returnObjects: true })

    return (
      <>
        {sharedResult && <h2 className={cn("sr-title")}>{t(`result.sr_title`)}</h2>}
        <h3 className={cn("sub-title")}>{t(`result.type${typeId}.subtitle`)}</h3>
        <h1 className={cn("main-title")}>{t(`result.type${typeId}.title`)}</h1>
        <img src={`./images/type/${typeList[type]["id"]}_1.png`} className={cn("type-image")} alt="" />
        <h4 className={cn("desc-text")}>{t(`result.type${typeId}.character`)}</h4>
        <section className={cn("detail-desc")}>
          <ul className={cn("desc-list")}>
            {typeof descList === "object"
              ? Object.values(descList).map((item, index) => <li key={index}>{item}</li>)
              : ""}
          </ul>
        </section>

        <section className={cn("percent")}>
          <h4 className={cn("title-text")}>{t(`result.percentage_title`)}</h4>

          <div className={cn("percent-num")}>{typeList[type]["result"]["percent"] + "%"}</div>
        </section>

        <section className={cn("chemistry")}>
          <div className={cn("cm_border")}>
            <a
              href={typeList[typeList[type]["result"]["chemistry_good"]]["result"]["detail_link"]}
              target="_blank"
              rel="noopener noreferrer"
            >
              <h5 className={cn("cm-title")}>{t(`result.good_chemistry`)}</h5>
              <img
                src={`images/type/${typeList[typeList[type]["result"]["chemistry_good"]]["id"]}_1.png`}
                className={cn("cm-image")}
                alt=""
              />
              <div className={cn("cm-desc")}>
                {t(`result.type${typeList[typeList[type]["result"]["chemistry_good"]]["id"]}.subtitle`)},
                <br />
                <span style={{ fontWeight: 600 }}>
                  {t(`result.type${typeList[typeList[type]["result"]["chemistry_good"]]["id"]}.title`)}
                </span>
              </div>
            </a>
          </div>
          <div className={cn("cm_border")}>
            <a
              href={typeList[typeList[type]["result"]["chemistry_bad"]]["result"]["detail_link"]}
              target="_blank"
              rel="noopener noreferrer"
            >
              <h5 className={cn("cm-title")}>{t(`result.bad_chemistry`)}</h5>
              <img
                src={`images/type/${typeList[typeList[type]["result"]["chemistry_bad"]]["id"]}_1.png`}
                className={cn("cm-image")}
                alt=""
              />
              <div className={cn("cm-desc")}>
                {t(`result.type${typeList[typeList[type]["result"]["chemistry_bad"]]["id"]}.subtitle`)},
                <br />
                <span style={{ fontWeight: 600 }}>
                  {t(`result.type${typeList[typeList[type]["result"]["chemistry_bad"]]["id"]}.title`)}
                </span>
              </div>
            </a>
          </div>
        </section>
      </>
    )
  }
}

const cn = classNames.bind(styles)

export default withTranslation()(ResultContents)
